import { useContext } from 'react'
import { GlobalStoreContext } from 'Components/store'
export default function useVisible() {
  const { state } = useContext(GlobalStoreContext)
  return state.isVisible
}
